import type { Kennzahl, GetValuesFn } from './types'

/**
 * Baut zwei parallele Datasets aus den Sub-Kennzahlen `{kennzahlId}1.` und `{kennzahlId}2.`
 * für LineChart und BarChart — ohne Achsentrennung.
 *
 * Verwendung: 1.2. (Einschreibungen + Zulassungen als zwei Serien)
 */
export function buildBarChartParallel(kennzahl: Kennzahl, getValues: GetValuesFn, baseYears: string[]): any {
    const valuesOne = getValues(`${kennzahl.kennzahlId}1.`)
    const valuesTwo = getValues(`${kennzahl.kennzahlId}2.`)

    if (!valuesOne.length && !valuesTwo.length) return false

    const dataOne: { x: string; y: number }[] = []
    const dataTwo: { x: string; y: number }[] = []
    let maxValue = 0

    valuesOne.forEach((v1) => {
        const match = valuesTwo.find((v2) => v2.semester === v1.semester)
        if (match) {
            dataOne.push({ x: match.semester, y: Number(v1.wert) })
            dataTwo.push({ x: v1.semester, y: Number(match.wert) })
            maxValue = Math.max(Number(match.wert), Number(v1.wert), maxValue)
        }
    })

    maxValue = maxValue ? maxValue * 1.15 : 10

    return {
        labels: baseYears,
        datasets: [
            {
                label: kennzahl.datasetLabels?.[1] ?? '',
                data: dataTwo,
                backgroundColor: '#E5007D',
                borderColor: '#E5007D',
                tension: 0,
                borderWidth: 1,
                pointRadius: 2,
                fill: false,
                maxValue
            },
            {
                label: kennzahl.datasetLabels?.[2] ?? '',
                data: dataOne,
                backgroundColor: '#004699',
                borderColor: '#004699',
                tension: 0,
                borderWidth: 1,
                pointRadius: 2,
                fill: false,
                maxValue
            }
        ]
    }
}
